import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { MutationFunction } from '@tanstack/react-query';

export interface UserRoleRequest {
  role: string;
  userId: string;
}

const updateUserRole: MutationFunction<boolean, UserRoleRequest> = async (
  args,
) => {
  if (isMockServices()) return await mock(_mockData);

  try {
    const authTokenHttp = await getCompatibleAuthTokenHttp();
    const response = await authTokenHttp<{
      success: boolean;
    }>(`/shared/users/${args.userId}/role`, {
      method: 'PUT',
      body: { role: args.role },
    });
    if (response.data) return response.data.success;
    throw new Error('Failed to update user role');
  } catch (error) {
    console.error('Failed to update user role:', error);
    // Re-throw so the caller can surface the backend message/errorCode
    // (e.g. the multi-tenant role-change block) instead of a generic failure.
    throw error;
  }
};

export default updateUserRole;

const _mockData: boolean = true;
